<template>
    <div>
        <div class="title" style="margin-left:10px">Console Administration</div>
        <div class="title is-4" style="margin-left:10px">Liste des utilisateurs</div>
        <s-button @onclick="sendMailsToUsers" label="Envoyer un mail" />
        
        <table border="1">
            <tr>
                <th>
                    Nom d'utilisateur
                </th>
                <th>
                    Email
                </th>
                 <th>
                    Login
                </th>
                <th>
                    Nombre de clubs crées
                </th>
                <th>
                    Nombre de clubs démo crées
                </th>
                <th>
                    Credit (gratuit / payé)
                </th>
            </tr>
            <tr v-for="user in users">
                <td>
                    {{user.displayName}}
                </td>
                <td>
                    {{user.email}}
                </td>
                  <td>
                    {{user.login}}
                </td>
                <td>
                    {{user.clubNormal}}
                </td>
                <td>
                    {{user.clubDemo}}
                </td>
                <td>
                    {{user.credit}}
                    /  <i>({{user.free}} - {{user.credit - user.free}})</i>
                </td>
                <td>
                    <div v-if="!user.test">
                    <s-button @onclick="autoriseTest(user.email)"
                        label="Le mettre Testeur"
                        theme="is-warning"/>
                    </div>
                    <div v-if="user.test">
                    <s-button @onclick="notAutoriseTest(user.email)"
                        label="Enlever testeur"
                        theme="is-info"/>
                    </div>
                </td>
                <td>
                    <s-button   
                        @onclick="openModalCredit(user.authId, user.email)"
                        label="Offrir des crédits"
                    />
                </td>
                <td v-if="user.clubs.length>0">
                    <s-button   
                        @onclick="openModalClubs(user.clubs)"
                        label="Voir les clubs"
                    />
                </td>
            </tr>
        </table>
        <s-modal
            :open="modalCredit"
            :close="true"
            @close="modalCredit=false"
            title="Offrir des crédits"
            :save="true"
            @save="sendCredit"
        >
            <s-input type="number" v-model="offerCredit" theme="is-primary"/>
        </s-modal>
        <waiting :open="openWaiting"/>
         <s-modal :open="openSendOk" :close="true" @close="openSendOk=false;modalCredit=false">
            L'envoie de vos crédits est bien partie. L'utilisateur sera informé, il pourra désormais les accepter. Attention, vous serez débité du nombre de crédits seulement lorsqu'il les aura accepter
        </s-modal>
        <s-modal :open="modalClubs" :close="true" @close="modalClubs=false">
            <div v-for="club in clubsSelected">
                <s-button @onclick="goClub(club.id)" :label="club.name"/>
            </div>

        </s-modal>
        <s-modal :open="modalSendMailToUser"
            :close="true"
            @close="modalSendMailToUser=false"
        >
           
            <div class="listEmailsCopy" >
                {{allEmails}}
            </div>
            <s-button @onclick="copyMails" label="Copier" theme="is-primary"/>
            
            <div class="listEmail">
                <div v-for="user in usersSendMail" style="width:100%;height: 40px">
                    {{user.email}} <div style="float:right"><s-button @onclick="deleteUserSendMail(user)" icon="trash" label="" theme="is-small is-danger"/></div>
                </div>
            </div>
            
        </s-modal>
    </div>
</template>
<style scoped>
    .listEmailsCopy {
        width: 90%;
        margin-bottom: 20px;
        border: thin solid black;
        padding: 5px;
    }
    .listEmail {
        margin: 20px;
        padding: 3px;
        overflow-y: auto;
        height: 300px;
        border: solid thin black;
    }
    td {
        text-align: center;
        color: color;
        padding-left: auto;
        padding-right: auto;
        font-size: 20px;
    }
    table {
        margin-left: 20px;
    }
</style>
<script>
import firebase_api from '@/firebase/firebase_api'
import firebase from 'firebase'
import mail_fct from "@/firebase/mails"
export default {
    data() {
        return {
            users: [],
            clubs: [],
            credits: {},
            orderBy: 'displayName',
            offerCredit: 0,
            modalCredit: false,
            selectAuthId : null,
            openWaiting: false,
            openSendOk:false,
            mailUser: null,
            clubsSelected: [],
            modalClubs: false,
            usersSendMail: [],
            messageMail: '',
            modalSendMailToUser: false,
            email: {
                subject: '',
                html: ''
            },
            editorOption: {
                theme: 'snow',
                
                modules: {
                    
                    toolbar: [
                    [{'size': ['small', false, 'large', 'huge']}],
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    ['clean'], ['link'] 
                    ],
                    
                }
             }
        };
    },
    computed: {
        allEmails: {
            get() {
                var emails = "";
                this.usersSendMail.forEach((user, indiceUser)=>{
                    emails += user.email 
                    if (indiceUser < this.usersSendMail.length-1)
                        emails += ', ';
                })
                return emails;
            }
        }
    },
    methods: {
        copyMails() {
            navigator.clipboard.writeText(this.allEmails);
        },
        deleteUserSendMail(userDelete) {
            
            var indexUser = this.usersSendMail.findIndex(elt=>elt.authId === userDelete.authId);
            this.usersSendMail.splice(indexUser, 1);
        },
        sendMailsToUsers() {
            this.users.forEach(user=>{
                if (user.clubs.length>0)
                    this.usersSendMail.push(user);
            })
            this.modalSendMailToUser = true;
        },
        openModalClubs(clubs) {
           
            this.clubsSelected = clubs;
            this.modalClubs = true;
        },
        goClub(club) {
              this.$router.push({name: "viewClub", 'params': {'id': club}}).catch(error=>{});
        },
        async refresh() {
            this.credits = [];
            this.frees = [];
            this.clubs = [];
            this.users = [];
             await firebase_api.api.getDb().collection("credit").get()
            .then(querySnapshot=>{
                querySnapshot.forEach(element => {
                    this.credits[element.id] = element.data().credit;
                    this.frees[element.id] = 0;
                    if (typeof( element.data().free)!="undefined")
                         this.frees[element.id] = element.data().free;

                })
            })
         await firebase_api.api.getDb().collection("club").get()
            .then(querySnapshot=>{
                querySnapshot.forEach(element => {
                    this.clubs.push(element.data());
                })
            })
        await firebase_api.api.getDb().collection("user").get()
            .then(querySnapshot=>{
                querySnapshot.forEach(element => {
                    var userItem = element.data();
                    var clubNormal = 0;
                    var clubDemo = 0;
                    userItem.clubs = [];                  
                   
                    this.clubs.forEach(clubItem=>{
                        
                        for (var idUser in clubItem.users) {
                            if (idUser==userItem.authId) {
                                
                                userItem.clubs.push(clubItem);
                                if (clubItem.demo)
                                    clubDemo++;
                                else    
                                    clubNormal++;
                            }
                        }
                    })
                    userItem.clubNormal = clubNormal;
                    userItem.clubDemo = clubDemo;
                    userItem.free = 0;
                    userItem.credit = 0;
                    if (typeof(this.credits[userItem.authId])!="undefined") {
                        userItem.credit = this.credits[userItem.authId]
                        userItem.free = this.frees[userItem.authId]
                    }
                    this.users.push(userItem);
                });
                
            })
       
        },
        autoriseTest(email) {
            firebase_api.api.getDb().collection("user").doc(email).update({
                test: true
            }).then(res=>{
                this.refresh();
            });
        },
        notAutoriseTest(email) {
            
              firebase_api.api.getDb().collection("user").doc(email).get().then(user=>{
                  
                  var userJson = user.data();
                  
                  delete userJson.test;
                  firebase_api.api.getDb().collection("user").doc(email).set(userJson).then(res=>{
                        this.refresh();
                    }); 
              })
        },
        openModalCredit(authId, email) {
            this.modalCredit = true;
            this.selectAuthId = authId;
            this.mailUser = email;
        },
        sendCredit() {
            const functions = firebase.app().functions('europe-west1');
            const params =  {
                type: "WELCOME",
                credit: this.offerCredit,
                email: this.mailUser,
                url: window.location
            }
            this.openWaiting = true;
            functions.httpsCallable("sendCredit")(params).then(res=>{
                this.openWaiting = false;
                this.openSendOk = true;
                var paramsMail= {
                    credit: this.offerCredit,
                    displayName: this.$store.getters.getUser.displayName,
                    url: window.location.origin 
                }
                mail_fct.object.sendEmail(this.mailUser, "SEND_OFFRE_CREDIT", paramsMail);    
                // on envoie le mail
                // on dit un message comme quoi c bon
                // il peut aller les voir dans l'historique
                // i lpeut les anneuler tant que ca n'a pas été pris
            })
        }
    },
    async mounted() {
       this.refresh();
    }
}
</script>